<template>
  <div class="app-container-wrapper">
    <head-container>
      <breadcrumb />
    </head-container>

    <div class="app-container p-t-20 no-title">
      <!--搜索--->
      <div class="card search">
        <el-form inline :model="filterForm" size="small" label-suffix="：">
          <el-form-item label="文件名称">
            <el-input
              v-model="filterForm.fileName"
              placeholder="请输入"
              maxlength="100"
              clearable
            />
          </el-form-item>
          <el-form-item class="operate">
            <el-button type="primary" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--列表---->
      <jczh-table-content
        ref="table"
        :data="listData"
        :option="tableOption"
        pagination
        :page.sync="page"
        :limit.sync="size"
        :total="total"
      >
        <template v-slot:last>
          <el-table-column
            label="操作"
            align="center"
            width="180"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-button
                v-if="row.status === fileDownloadStatusDict.SUCCESS.value"
                type="text"
                @click="save(row)"
              >
                保存至本地
              </el-button>
              <el-button
                v-if="
                  Number(row.status) > fileDownloadStatusDict.UN_DOWNLOAD.value
                "
                type="text"
                class="text-danger"
                @click="deleteItem(row)"
              >
                删除
              </el-button>
              <el-button
                v-if="Number(row.status) === fileDownloadStatusDict.FAIL.value"
                type="text"
                @click="reDownload(row)"
              >
                重新下载
              </el-button>
            </template>
          </el-table-column>
        </template>
      </jczh-table-content>
    </div>
  </div>
</template>
<script>
import HeadContainer from '@/components/common/HeadContainer'
import Breadcrumb from '@/components/common/Breadcrumb/Breadcrumb'

import {
  getDownloadListApi,
  deleteDownloadFileApi,
  reDownloadFileApi,
  getAccessFileApi
} from '@/api/up-file'

import listFilterMixin from '@/mixins/list-filter-mixin'

import { fileDownloadStatusDict } from '@/dictionary/system'

import { mapState } from 'vuex'
export default {
  name: 'DownloadManagement',

  components: {
    HeadContainer,
    Breadcrumb
  },

  mixins: [listFilterMixin],

  data() {
    return {
      fileDownloadStatusDict,

      page: 1,
      size: 10,
      filterForm: {
        fileName: ''
      },

      listData: [],
      total: 0,
      tableOption: [
        { prop: 'fileName', label: '文件名称', minWidth: 120 },
        {
          prop: 'status',
          label: '下载状态',
          minWidth: 120,
          filter: el => fileDownloadStatusDict.translate(el).label || '-'
        },
        { prop: 'downloadTime', label: '下载时间', minWidth: 120 }
      ]
    }
  },

  created() {
    this.getList()
  },

  methods: {
    /**
     * 获取列表
     */
    async getList() {
      try {
        const { data = {} } = await getDownloadListApi(
          process.env.VUE_APP_PLATFORM_CONSTANT,
          {
            page: this.page,
            size: this.size,
            ...this.filterForm
          }
        )
        this.listData = (data.records || []).map(el => ({
          ...el,
          fileName: el.downloadInfo?.fileName,
          downloadTime: el.downloadInfo?.downloadTime,
          completeTime: el.downloadInfo?.completeTime
        }))
        this.total = data?.total || 0
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 删除
     */
    async deleteItem(row) {
      try {
        await deleteDownloadFileApi(row.downloadId)
        this.$message.success('删除成功')
        await this.getList()
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 重新下载
     */
    async reDownload(row) {
      try {
        await reDownloadFileApi(row.downloadId)
        this.$message.success('重新下载')
        await this.getList()
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 保存至本地
     */
    async save(row) {
      try {
        const { data } = await getAccessFileApi(row.downloadId)
        const url = data || ''
        window.open(url, '_blank')
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
